
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { ResourceTimeOffEntryDto } from '../../../models/resource.models';
import { formatWeekdayDate } from '../../../utils/time-off-days.utils';
import { TimeOffCarryOverSummaryComponent } from '../time-off-carry-over-summary/time-off-carry-over-summary.component';

@Component({
  selector: 'app-time-off-event-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    RouterLink,
    TimeOffCarryOverSummaryComponent,
  ],
  templateUrl: './time-off-event-dialog.component.html',
  styleUrls: ['./time-off-event-dialog.component.scss'],
})
export class TimeOffEventDialogComponent {
  dialogRef = inject<MatDialogRef<TimeOffEventDialogComponent>>(MatDialogRef);
  data = inject<ResourceTimeOffEntryDto>(MAT_DIALOG_DATA);


  get employeeMeta(): string {
    const parts = [
      this.data.classYear?.trim() || null,
      this.data.seniority?.trim() || null,
    ].filter((p): p is string => p !== null);
    return parts.join(' - ');
  }

  /** The date card's From and To; same format as the carry-over dates below them. */
  formatDate(dateStr?: string): string {
    return dateStr ? formatWeekdayDate(dateStr) : '—';
  }
}
